export enum BroadcastNetwork {
  ALL_NETWORKS = 'ALL_NETWORKS',
  HUBLO_POOL_NETWORK = 'HUBLO_POOL_NETWORK',
  AGENCY_NETWORK = 'AGENCY_NETWORK',
}
